import React, {useState, useEffect} from 'react';
import * as S from './PanCardDetails.styles';
import * as C from '../../../Common.styles';
import {sendEvarData} from '@ibibo/analytics';
import {UploadFile} from '../../../../UI/UploadBlock/UploadFile';
import UploadInfo from '../../../UI/UploadInfo/UploadInfo';
import UploadReset from '../../../UI/UploadInfo/UploadReset';
import {validations} from '../../../../../../utils/validations';

const PanCardDetails = ({onUpload, cancelPAN, data, errors, updateData, apiError, status}) => {

    const [{
        agencyName,
        panNumber,
        panUploaded,
        panVerified,
        panSuccess,
        pan_name,
        pan_type,
        user_msg,
    },setPanDetails] = useState({
        agencyName: data.agencyName || '',
        panNumber: data.panNumber || '',
        panUploaded: data.panUploaded || false,
        panVerified: data.panVerified || false,
        panSuccess: data.panSucces || false,
        pan_name: data.pan_name || '',
        pan_type: data.pan_type || false,
        user_msg: data.user_msg || '',
    });

    useEffect(() => {
        setPanDetails({
            agencyName: data.agencyName || agencyName,
            panNumber: data.panNumber || panNumber,
            panUploaded: data.panUploaded || panUploaded,
            panVerified: data.panVerified || panVerified,
            panSuccess: data.panSuccess || panSuccess,
            pan_name: data.pan_name || pan_name,
            pan_type: data.pan_type || pan_type,
            user_msg: data.user_msg || user_msg
        })
    }, [data]);

    useEffect(() => {
        if (!data.panUploaded) {
            setPanDetails({
                agencyName: agencyName,
                panNumber: panNumber,
                panUploaded: false,
                panVerified: false,
                panSuccess: false,
                pan_name: '',
                pan_type: false,
                user_msg: '',
            });
        }
    }, [data.panUploaded]);

    const [{fileSize, fileName, sizeError, fileSuccess, upload}, setFileInfo] = useState({
        fileSize: 0,
        fileName: '',
        sizeError: null,
        fileSuccess: true,
        upload: true,
    });

    let isUploadPanEnabled = agencyName !== '' && panNumber !== '' ? true : false;

    const [{tooltipAgency, tooltipPan}, setToolTip] = useState({
        tooltipAgency: false,
        tooltipPan: false,
    });

    const [panFile, setPanFile] = useState({
        panFile: {}
    })

    const [showName, setShowName] = useState(false);
    const [nameCorrectPop, setNameCorrectPop] = useState(true);
    const [popVisible, setPopVisible] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [showClose, setShowClose] = useState(false);
    const [error, setError] = useState({});
    const [fullNameError, setFullNameError] = useState(false);
    const [apiErrorMsg, setApiError] = useState(apiError);

    useEffect(() => {
        setApiError(apiError);
    },[apiError]);
    
    if (status === 'confirmed') {
        setShowClose(false);
    }

    const successCallBack = (resp) => {
        if(resp.individual){
            setFullNameError(true);
        }
        if(resp.pan_name && !resp.individual){
            setShowName(true);
        }
    }

    const uploadPanNumber = (correctName = false) => {
        const panFileSize = panFile.size / 1024 / 1024;
        setFullNameError(false);
        if (panFileSize < 5) {
          setFileInfo({
            fileSize: panFileSize,
            fileName: panFile.name,
            sizeError: null,
            fileSuccess: false,
            upload: false,
          });
          onUpload({panNumber, agencyName: (correctName ? pan_name : agencyName ) , panFile, successCallBack});
        } else {
          setFileInfo({
            fileSize: panFileSize,
            fileName: panFile.name,
            sizeError: 'File size must be less than 5MB',
            fileSuccess: true,
            upload: false,
          });
        }
        setNameCorrectPop(true);
    };
    
    const fieldValidators = {
        agencyName: {fieldName: 'Agency Name', validators: ['required', 'validAddress']},
        panNumber: {fieldName: 'PAN', validators: ['required', 'validPAN']},
    };

    const validateFields = data => {
        let errorObj = {};
        Object.keys(data).map(key => {
        if (fieldValidators[key]) {
            const validators = fieldValidators[key].validators;
            for (let i = 0; i < validators.length; i++) {
            const validateFunction = validations[validators[i]];
            const resp = validateFunction({
                value: data[key],
                fieldName: fieldValidators[key].fieldName
            });
            if (resp && !errorObj[key]) {
                errorObj[key] = resp;
            }
            }
        }
        });
        setError(errorObj);
        if (Object.keys(errorObj).length) {
        return true;
        }
        return false;
    };

    const showUploadPan = () => {
        const panTest = document.getElementById('panUpload').files[0];
        setPanFile(panTest);
        if(!popVisible){
            const urlShow = URL.createObjectURL(document.getElementById('panUpload').files[0]);
            setFileUrl(urlShow);
            setPopVisible(true);
        }
    }

    const clearUploadData = () => {
        sendEvarData({
          prop54: "myPartner|signup|businessVerification|removeDocument|PAN"
        }, true)
        setFileInfo({fileSize: null, fileName: null, sizeError: null, fileSuccess: true, upload: true});
        isUploadPanEnabled = false;

        setToolTip({tooltipAgency: false, tooltipPan: false});
    };

    const resetUpload = () => {
        clearUploadData();
        cancelPAN();
    };

    let uploadBlock = (
        <S.KycLabelWrap>
            <UploadFile change={showUploadPan} toDisabled={!isUploadPanEnabled} />
            {sizeError !== '' ? <C.ErrorText>{sizeError}</C.ErrorText> : ''}
            <C.ErrorText>{errors['panDoc']}</C.ErrorText>
        </S.KycLabelWrap>
    );
    if (!fileSuccess) {
        uploadBlock = <UploadInfo filesize={fileSize} filename={fileName} reset={resetUpload} />;
    }
    if (panUploaded && (!fileName || fileName === '')) {
        uploadBlock = <UploadReset reset={resetUpload} close={showClose} />;
    }

    const onPanClick = () => {
        if (!upload) {
          setToolTip({tooltipAgency: false, tooltipPan: !tooltipPan});
        }
    };

    const cancelEvent = () => {
        setPopVisible(false);
        resetUpload();
        setFileUrl('');
    }

    const agreeEvent = () => {
        sendEvarData({
          prop54: "myPartner|signup|businessVerification|docPreview|PAN"
        }, true)
        setPopVisible(false);
        uploadPanNumber();
        setFileUrl('');
    }

    const cancelPanNameEvent = () => {
        setShowName(false);
        resetUpload();
        setPanDetails({
            agencyName: pan_name,
            panNumber,
            panUploaded,
            panVerified,
            panSuccess,
            pan_name,
            pan_type: false,
            user_msg,
        });
    }
    
    const agreeNameEvent = () => {
        if(!pan_type){
            setPanDetails({
                agencyName: pan_name,
                panNumber,
                panUploaded,
                panVerified,
                panSuccess,
                pan_name,
                pan_type,
                user_msg,
            });
            uploadPanNumber(true);
        } else{
            uploadPanNumber();
        }
        setShowName(false);
    }

    const onAgencyClick = () => {
        if (!upload) {
          setToolTip({tooltipAgency: !tooltipAgency, tooltipPan: false});
        }
    };

    let EditToolTip = <S.InfoToolTip>Please remove pan card to edit.</S.InfoToolTip>;
    
    const onChangeHandler = (field, value) => {
        const data = {
            agencyName,
            panNumber,
            panUploaded,
            panVerified,
            panSuccess,
            pan_name,
            pan_type,
            user_msg
        };
        data[field] = value;
        setPanDetails(data);
        let hasError = validateFields(data);
        if(!hasError){
            updateData(data);
        }
    }

    return(
        <S.PanInfoWrap>
            <S.PanCardInfoWrap>
                <S.PanCardInfoHeadWrap>
                    <span />
                    <S.PanCardInfoHeadText>PAN Details</S.PanCardInfoHeadText>
                </S.PanCardInfoHeadWrap>
            </S.PanCardInfoWrap>
            <S.PanCardInfoMainWrap>
                <S.PanCardInfoRowWrap>
                    <S.AgencyNameInputWrap>
                        <C.CommonLabel>Agency Name</C.CommonLabel>
                        <C.CommonInput
                            readOnly={!upload ? true : false}
                            type="text"
                            name="agencyName"
                            placeholder="Agency Name"
                            value={agencyName}
                            onChange={event => onChangeHandler('agencyName', event.target.value)}
                            onBlur={event => onChangeHandler('agencyName', event.target.value)}
                            hasError={error['agencyName'] ? true : false}
                            onClick={onAgencyClick}
                        />
                        <C.ErrorText>{error['agencyName']}</C.ErrorText>
                        {tooltipAgency ? EditToolTip : null}
                    </S.AgencyNameInputWrap>
                    <S.PanCardNumberInputWrap>
                        <C.CommonLabel>PAN Number</C.CommonLabel>
                        <C.CommonInput
                            isPAN
                            readOnly={!upload ? true : false}
                            type="text"
                            name="panNumber"
                            placeholder="Pan Number"
                            value={panNumber}
                            onChange={event => onChangeHandler('panNumber', event.target.value)}
                            onBlur={event => onChangeHandler('panNumber', event.target.value)}
                            hasError={error['panNumber'] ? true : false}
                            onClick={onPanClick}
                            maxLength={10}
                        />
                        <C.ErrorText>{error['panNumber']}</C.ErrorText>
                        {tooltipPan ? EditToolTip : null}
                    </S.PanCardNumberInputWrap>
                </S.PanCardInfoRowWrap>
                <S.PanCardInfoRowWrap>
                    <S.UploadPicInfoWrap>
                        <S.UploadPanHeadText>Upload PAN Card</S.UploadPanHeadText>
                        <S.UploadPanSubText>Please ensure that the uploaded image is not blurry and your <strong>Full Name, PAN, Signature and Photo</strong> are clearly visible.</S.UploadPanSubText>
                    </S.UploadPicInfoWrap>
                    <S.UploadBlockWrap>
                        {uploadBlock}
                    </S.UploadBlockWrap>
                </S.PanCardInfoRowWrap>
                <C.ApiErrorText>
                    {!panSuccess && !showName && apiErrorMsg && apiErrorMsg.screen === 'details' ? apiErrorMsg.msg : ''}
                    {fullNameError && `The name against the uploaded PAN card doesn't match the provided name`}
                </C.ApiErrorText>
            </S.PanCardInfoMainWrap>
            {popVisible && (
                <C.PanCardUploadImageView>
                    <C.PanCardUploadPreviewWrap>
                        <C.PanCardUploadHeadText>Upload Preview</C.PanCardUploadHeadText>
                        <C.PanCardUploadImgWrap>
                            <C.PanCardImgiewver>
                                <img src={fileUrl} alt="uploded pan" width="100%" height="auto" />
                            </C.PanCardImgiewver>
                        </C.PanCardUploadImgWrap>
                        <C.PanCardUploadBtnWrap>
                            <C.UploadAgainBtn onClick={cancelEvent}>Upload Again</C.UploadAgainBtn>
                            <C.ApproveBtn onClick={agreeEvent}>Upload</C.ApproveBtn>
                        </C.PanCardUploadBtnWrap>
                    </C.PanCardUploadPreviewWrap>
                </C.PanCardUploadImageView>
            ) || null}
            {showName && (
                <C.PanCardUploadImageView>
                    <C.PanCardUploadPreviewWrap>
                        <C.PanCardUploadHeadText>PAN Name Verification</C.PanCardUploadHeadText>
                        <S.PanCardNameInfoWrap>
                            <S.PanCardNameInfoText>{user_msg}</S.PanCardNameInfoText>
                        </S.PanCardNameInfoWrap>
                        <C.PanCardUploadBtnWrap>
                            <C.UploadAgainBtn onClick={cancelPanNameEvent}>Upload Again</C.UploadAgainBtn>
                            <C.ApproveBtn onClick={agreeNameEvent}>Confirm Name</C.ApproveBtn>
                        </C.PanCardUploadBtnWrap>
                    </C.PanCardUploadPreviewWrap>
                </C.PanCardUploadImageView>
            )}
            
        </S.PanInfoWrap>
    )
}

export default PanCardDetails;